import React, { Component, Fragment } from 'react';
import { Container, Row, Col } from 'react-grid-system';
import { withRouter } from 'react-router';

import { translate } from 'components/translate';
import { UserInfo } from 'components/user';
import { createSelectOptions } from 'helpers/Object';
import { ClassesService } from 'modules/content';
import MembershipService from 'modules/membership/MembershipService';
import { UiService } from 'modules/ui';
import { UserManagerService } from 'modules/userManager';
import { USER_STATUS, USER_ROLES_LABEL } from 'modules/userManager/constants';
import PropTypes from 'prop-types';

import PlusAccessModal from './PlusAccessModal';
import UpdateDataModal from './UpdateDataModal';
import UserDetailPlusAccess from './UserDetailPlusAccess';
import UserDetailSelect from './UserDetailSelect';

import './UserDetailHeader.scss';

const dataToUpdate = {
  membershipClass: 'membershipClass',
  role: 'role'
};

@withRouter
@translate()
export default class UserDetailHeader extends Component {
  static propTypes = {
    history: PropTypes.object,
    t: PropTypes.func,
    userData: PropTypes.object
  };

  state = {
    membershipClass: {
      open: false
    },
    role: {
      open: false
    },
    classesList: [],
    rolesList: [],
    showUpdateDataModal: false,
    showPlusAccessModal: false,
    modalTitle: '',
    newClass: {},
    newRole: {},
    userAccessLabel: '',
    userData: {}
  };

  async componentDidMount() {
    await this.initializeClasses();
  }

  componentDidUpdate() {
    const { userData } = this.props;
    const { classesList, userAccessLabel } = this.state;

    this.initializeRole(userData);

    this.initializeClass(userData, classesList);

    this.initializeUserData(userData, userAccessLabel);
  }

  async initializeClasses() {
    const classesList = await ClassesService.getSelectFormatedClasses();

    this.setState({ classesList });
  }

  initializeRole(userData) {
    if (userData.userRole && !this.state.role.value) {
      const role = this.rolesList.find(
        (role) => role.value === userData.userRole
      );

      this.setState((prevState) => ({
        [dataToUpdate.role]: {
          ...prevState[dataToUpdate.role],
          ...role
        }
      }));
    }
  }

  initializeClass(userData, classesList) {
    if (
      userData.userClassId &&
      !this.state.membershipClass.value &&
      classesList.length
    ) {
      const membershipClass = classesList.find(
        (classObj) => classObj.value === userData.userClassId
      );

      if (membershipClass) {
        this.setState((prevState) => ({
          [dataToUpdate.membershipClass]: {
            ...prevState[dataToUpdate.membershipClass],
            ...membershipClass
          }
        }));
      }
    }
  }

  initializeUserData(userData, userAccessLabel) {
    if (userData.userStatus && !userAccessLabel) {
      const newUserAccessLabel = this.userAccessLabel(userData.userStatus);

      this.setState({ userAccessLabel: newUserAccessLabel, userData });
    }
  }

  userAccessLabel(userStatus) {
    return userStatus && UserManagerService.getStatusLabel(userStatus);
  }

  setData(newData, field) {
    const data = this.state[field];
    const modalTitle =
      field === dataToUpdate.membershipClass
        ? 'users_manager.users_detail.class_modal_title'
        : 'users_manager.users_detail.role_modal_title';

    const modalHeader =
      field === dataToUpdate.membershipClass
        ? 'users_manager.users_detail.class_modal_header'
        : 'users_manager.users_detail.role_modal_header';

    const dataLabel =
      field === dataToUpdate.membershipClass ? 'newClass' : 'newRole';

    if (data.value !== newData.value) {
      this.setState({
        showUpdateDataModal: true,
        modalTitle,
        modalHeader,
        userDataToUpdate: field,
        [dataLabel]: newData
      });
    }
  }

  openPlusAccessModal() {
    this.setState({ showPlusAccessModal: true });
  }

  closeModal() {
    this.setState({
      showUpdateDataModal: false,
      showPlusAccessModal: false,
      userDataToUpdate: '',
      modalTitle: ''
    });
  }

  async confirmModal() {
    const { userData } = this.props;
    const { userDataToUpdate, newClass, newRole } = this.state;
    const userAreaId = userData.id;

    if (dataToUpdate.membershipClass === userDataToUpdate) {
      const userData = {
        classId: newClass.value,
        userAreaIds: [userAreaId]
      };

      await UserManagerService.userChangeClass(userData);

      UiService.setAlertSuccess('done');

      this.setState({ membershipClass: newClass });

      this.closeModal();
    } else {
      await UserManagerService.userChangeRole(userAreaId, newRole.value);

      UiService.setAlertSuccess('done');

      this.setState({ role: newRole });

      this.closeModal();
    }
  }

  goToUsersScreen(eventType) {
    const { userData } = this.state;
    const actionDelete = 'DELETE';

    if (eventType === actionDelete) {
      this.props.history.push(MembershipService.getLink('userManager'));
    } else {
      userData.userStatus =
        userData.userStatus === USER_STATUS.ACTIVE
          ? USER_STATUS.BLOCKED_BY_OWNER
          : USER_STATUS.ACTIVE;

      this.setState({ userData });
    }
  }

  get rolesList() {
    const { t } = this.props;

    const typesLabels = ['ADMIN', 'CONTENT_EDITOR', 'STUDENT', 'MODERATOR'];
    const typesValues = [
      t(USER_ROLES_LABEL.ADMINISTRATOR),
      t(USER_ROLES_LABEL.CONTENT_EDITOR),
      t(USER_ROLES_LABEL.STUDENT),
      t(USER_ROLES_LABEL.MODERATOR)
    ];

    return createSelectOptions(typesLabels, typesValues);
  }

  render() {
    const {
      userData,
      role,
      membershipClass,
      classesList,
      showUpdateDataModal,
      showPlusAccessModal,
      modalTitle,
      modalHeader
    } = this.state;

    return (
      <Fragment>
        <Container fluid className="user__detail__header">
          <Row justify="between">
            <Col xs={12} sm={3.6}>
              <UserInfo
                name={userData.userName}
                email={userData.userEmail}
                pictureThumbId={userData.userPictureThumbId}
                pictureFileKey={userData.userPictureFileKey}
                role={UserManagerService.getRoleLabel(userData.userRole)}
              />
            </Col>

            <UserDetailSelect
              label="users_import.manually.class.label"
              value={membershipClass}
              placeholder="users_import.manually.class.placeholder"
              options={classesList}
              onChange={(newClass) =>
                this.setData(newClass, dataToUpdate.membershipClass)
              }
            />

            <UserDetailSelect
              label="users_import.manually.role.label"
              value={role}
              placeholder="users_import.manually.role.placeholder"
              options={this.rolesList}
              onChange={(newRole) => this.setData(newRole, dataToUpdate.role)}
            />

            <UserDetailPlusAccess
              userData={userData}
              onUpdate={this.goToUsersScreen.bind(this)}
              activeLabel={this.userAccessLabel(userData.userStatus)}
              onClick={this.openPlusAccessModal.bind(this)}
            />
          </Row>
        </Container>
        {showUpdateDataModal && (
          <UpdateDataModal
            confirmModal={this.confirmModal.bind(this)}
            closeModal={this.closeModal.bind(this)}
            title={modalTitle}
            description={modalHeader}
            isOpen={showUpdateDataModal}
          />
        )}
        {showPlusAccessModal && (
          <PlusAccessModal
            closeModal={this.closeModal.bind(this)}
            userPlusAccess={userData.userPlusAccess}
            dependents={userData.dependents}
            isOpen={showPlusAccessModal}
          />
        )}
      </Fragment>
    );
  }
}
